import React from 'react';
import { RouteIcon } from 'lucide-react';
import type { NoteField } from '../../types/disclosure';
interface NotesPanelProps {
  notes: NoteField[];
  showApiNames: boolean;
}
export function NotesPanel({
  notes,
  showApiNames
}: NotesPanelProps) {
  const [primary, ...supporting] = notes;
  return <div className="space-y-4" data-id="element-41" data-mp="37xm4btikmxom">
      <article className="overflow-hidden rounded-md border border-blue-200 bg-blue-50/40" data-id="element-42" data-mp="37wkutth7ej90">
        <header className="flex items-center gap-2 border-b border-blue-200 bg-blue-100/60 px-3.5 py-2" data-id="element-43" data-mp="32ysrm3b3zapi">
          <RouteIcon className="h-4 w-4 text-blue-700" aria-hidden="true" data-id="element-44" data-mp="2xxbtugnx84d5" />
          <h3 className="text-xs font-semibold uppercase tracking-wide text-blue-900" data-id="element-45" data-mp="2t0v5blct7nzj">{primary.label}</h3>
          {showApiNames && <span className="font-mono text-[10px] text-blue-600" data-id="element-46" data-mp="2ozt5b2b2j7wi">{primary.api}</span>}
        </header>
        <div className="min-h-[220px] px-4 py-3.5" data-id="element-47" data-mp="r7x9dgnqkfad">
          {primary.value ? <p className="whitespace-pre-line text-sm leading-6 text-slate-800" data-id="element-48" data-mp="n86kxjlomb90">{primary.value}</p> : <p className="text-sm italic text-slate-400" data-id="element-49" data-mp="37lypnutjw9yd">No roadmap notes recorded.</p>}
        </div>
      </article>

      <div className="grid gap-2.5 sm:grid-cols-2" data-id="element-50" data-mp="3ck9yq3c0ugfj">
        {supporting.map(note => <article key={note.id} className="flex min-h-[112px] flex-col rounded-md border border-slate-200 bg-white px-3.5 py-3" data-id="element-51" data-mp="2yoy5y1hff019">
            <h3 className="text-[11px] font-semibold uppercase tracking-wide text-slate-500" data-id="element-52" data-mp="3qfc9p4vq6vz7">{note.label}</h3>
            {showApiNames && <p className="font-mono text-[10px] text-slate-400" data-id="element-53" data-mp="3vf8f98k2mvgv">{note.api}</p>}
            {note.value ? <p className="mt-1.5 whitespace-pre-line text-[13px] leading-6 text-slate-800" data-id="element-54" data-mp="3hjwlp4hnjb1j">{note.value}</p> : <p className="mt-1.5 text-[13px] italic text-slate-400" data-id="element-55" data-mp="d6zh5xicuxfg">Not provided</p>}
          </article>)}
      </div>
    </div>;
}